export const PAYMENT_CART_HEADER = {
    HEADING: "payment-cart-screen-heading",
    SUB_HEADING: "payment-cart-screen-subHeading",
    YOU_PAY: "you-pay",
    SETTLE_BILL_FOOTER: "settle-bill-footer-header",
    FOOTER_BUTTON_: "full-width-button-{0}",
    SETTLE_BILL_CTA_LIST: "reserve-cta-list",
    SETTLE_BILL_POPUP_PRESS: "settle-bill-popup-press",
    SETTLE_BILL_POPUP_BACK: "settle-bill-popup-goback",
    SETTLE_BILL_POPUP_HEADER: "settle-bill-popup-header",
    APPLIED_COUPON_CODE: "applied-coupon-code",
    DINEOUT_REMOVE_COUPON: "dineout-remove-coupon",
    PAYMENT_CART_HEADER: "payment-cart-header",
};
